if (!customElements.get('service-adder')) {
  customElements.define(
    'service-adder',
    class ServiceAdder extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('.js-service-checkbox');
        this.select = this.querySelector('select');
        this.dropdownWrapper = this.querySelector('.js-service-dropdown-wrapper');
        this.valueDisplay = this.querySelector('[data-selected-color-value]');
      }

      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form) return;

        this.buyNowButton = this.form.querySelector('shopify-buy-it-now-button');

        this.updateAllStates = this.updateAllStates.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.onPageShow = () => this.updateAllStates();

        this.form.addEventListener('change', this.updateAllStates);
        window.addEventListener('pageshow', this.onPageShow);

        if (this.select) {
          this.select.addEventListener('change', this.handleSelectChange);
        }
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('change', this.updateAllStates);
        if (this.select) this.select.removeEventListener('change', this.handleSelectChange);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      updateAllStates() {
       
        const allCheckedInputs = Array.from(document.querySelectorAll('variant-selects option:checked, variant-selects input:checked'));

        // Adtrip 11.2026: srebrny po ID wartości opcji (niezależne od języka); tytan sprawdza już Liquid
        const silverIds = (this.closest('[data-silver-ids]')?.dataset.silverIds || '').split(',').filter(Boolean);
        const isSilver = allCheckedInputs.some((el) => silverIds.includes(el.dataset.optionValueId));

        const sterilizationInput = this.form.querySelector('input[id*="sterilization"]');
        const giftInput = this.form.querySelector('input[id*="gift-wrapping"]');
        // const anodizationInput = this.form.querySelector('input[id*="anodization"]');

        const isSterilizationChecked = sterilizationInput ? sterilizationInput.checked : false;
        const isGiftChecked = giftInput ? giftInput.checked : false;
        // const isAnodizationChecked = anodizationInput ? anodizationInput.checked : false;

        const canShowSterilization = !isGiftChecked;
        const canShowAnodization = isSilver;
        const canShowGift = !isSterilizationChecked;

        const isThisSterilization = this.checkbox.id.includes('sterilization');
        const isThisAnodization = this.checkbox.id.includes('anodization');
        const isThisGift = this.checkbox.id.includes('gift');

        let shouldBeVisible = true;

        if (isThisSterilization) shouldBeVisible = canShowSterilization;
        if (isThisAnodization) shouldBeVisible = canShowAnodization;
        if (isThisGift) shouldBeVisible = canShowGift;

        if (shouldBeVisible) {
          this.classList.remove('hidden');
          this.checkbox.disabled = false;
        } else {
          this.classList.add('hidden');
          this.checkbox.disabled = true;
          if (this.checkbox.checked) {
            this.checkbox.checked = false;
          }
        }

        if (this.dropdownWrapper) {
          if (this.checkbox.checked && !this.checkbox.disabled) {
            this.dropdownWrapper.classList.remove('hidden');
            this.dropdownWrapper.style.display = 'block';
          } else {
            this.dropdownWrapper.classList.add('hidden');
            this.dropdownWrapper.style.display = 'none';
          }
        }

        this.updateBuyNowButton();
      }

      updateBuyNowButton() {
        const anyServiceChecked = Array.from(this.form.querySelectorAll('.js-service-checkbox')).some((cb) => cb.checked && !cb.disabled);

        if (this.buyNowButton) {
          this.buyNowButton.style.display = anyServiceChecked ? 'none' : '';
        }

        this.form.querySelectorAll('.at-payment-btns').forEach((btn) => {
          btn.classList.toggle('at-payment-btns--visible', !anyServiceChecked);
        });
      }

      handleSelectChange() {
        const selectedOption = this.select.options[this.select.selectedIndex];
        const newValue = selectedOption.text.trim();
        const newId = this.select.value;

        if (this.checkbox) this.checkbox.dataset.serviceVariantId = newId;
        if (this.valueDisplay) this.valueDisplay.textContent = newValue;
      }
    }
  );
}
